import beipanjiang from "./index.vue";
import beipanjiangHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const errorRecord = () => import("./../../components/ErrorRecordControl.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const SimpleHumidityList = () => import("../../components/SimpleHumidityList.vue");
const gasClamp = () => import("./gasClamp.vue");
const gasClampTrial = () => import("./gasClampTrial.vue");
const cableClamp = () => import("./cableClamp.vue");
const highFrequencyCurrentData = () => import("./../../components/HighFrequencyCurrentData.vue");
const highFrequencyStatusControl = () => import("./../../components/HighFrequencyStatusControl.vue");
const login = () => import("./login.vue");

const station = () => import("./station.vue");

export default [
  {
    path: "/beipanjiangIndex",
    name: "beipanjiangIndex",
    component: beipanjiangHome,
  },
  {
    path: "/beipanjiang/login",
    name: "beipanjiangLogin",
    component: login,
  },
  {
    path: "/beipanjiang",
    name: "beipanjiang",
    redirect: "/beipanjiang",
    component: beipanjiang,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "currentHumidityList",
        name: "currentHumidityList",
        component: SimpleHumidityList,
      },
      {
        path: "highFrequencyCurrentData",
        name: "highFrequencyCurrentData",
        component: highFrequencyCurrentData,
      },
      {
        path: "highFrequencyStatusControl",
        name: "highFrequencyStatusControl",
        component: highFrequencyStatusControl,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      {
        path: "gasClamp",
        name: "gasClamp",
        component: gasClamp,
      },
      {
        path: "gasClampTrial",
        name: "gasClampTrial",
        component: gasClampTrial,
      },
      {
        path: "cableClamp",
        name: "cableClamp",
        component: cableClamp,
      },
      {
        path: "station",
        name: "station",
        redirect: "/beipanjiang/station/east",
        component: emptyComponent,
        children: [
          {
            path: "east",
            name: "east",
            component: station,
          },
          {
            path: "west",
            name: "west",
            component: station,
          },
        ],
      },
    ],
  },
];
